<template>
  <div class="bg-white p-4">
    <div class="flex flex-row justify-end">
      <el-select class="" v-model="defaultChartType" placeholder="Select">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="flex justify-between flex-no-wrap">
      <div class="table-section">
        <el-table
          :data="recencyCounts"
          :empty-text="'No Data available'"
          :default-sort = "{prop: 'count', order: 'descending'}"
          style="width: 100%">
          <el-table-column
            prop="id"
            label="Segment Label"
            width="200px">
            <template slot-scope="scope">
              <span>{{capitalize(scope.row.id)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="count"
            label="Customer Count">
          </el-table-column>
        </el-table>
      </div>
      <div class="chart-section">
        <GChart
          v-if="chartDataValue.length > 2"
          class="charts"
          :type="defaultChartType"
          :data="chartDataValue"
          :options="chartOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts';
import Constants from '../../../Constants';

export default {
  name: 'Recency',
  components: {
    GChart,
  },
  data() {
    return {
      options: Constants.chart_types,
      defaultChartType: 'PieChart',
    };
  },
  computed: {
    recencyCounts() {
      if (this.$store.state.AICustomers.rfm_counts && this.$store.state.AICustomers.rfm_counts.recency_scores) {
        const segments = this.$store.state.AICustomers.rfm_counts.recency_scores;
        const data = [];
        Object.keys(segments).forEach((item) => {
          data.push({
            id: this.capitalize(Constants.rfm[item]),
            count: segments[item],
          });
        });

        return data;
      }
      return [];
    },

    chartDataValue() {
      return this.chartData();
    },

    chartOptions() {
      if (this.defaultChartType === 'BarChart') {
        // Get Bar Chart Data
        return {
          title: 'Customers Recency Chart',
          height: '400',
          bar: { groupWidth: '95%' },
          legend: { position: 'none' },
        };
      }

      if (this.defaultChartType === 'PieChart') {
        // Get Pie Chart Data
        return {
          title: 'Customers Recency Chart',
          pieHole: 0.4,
        };
      }

      return {};
    },
  },
  methods: {
    chartData() {
      const recency = this.$store.state.AICustomers.rfm_counts.recency_scores || {};

      if (Object.keys(recency).length > 0) {
        const data = [
          ['Recency Title', 'Customers', { role: 'style' }],
        ];

        Object.keys(recency).forEach((item, index) => {
          data.push([this.capitalize(Constants.rfm[item]), recency[item], Constants.colors[index]]);
        });

        return data;
      }

      return [];
    },
  },
};
</script>

<style scoped lang="scss">
  .table-section {
    flex: 0 1 35%
  }

  .chart-section {
    flex: 0 1 63%
  }

  .charts {
    flex: 0 1 100%;
  }
</style>
